<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('gameSetting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('gameSetting.pageTitle'),
            href: '/game-settings'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-shadow-md">
            <h2
              class="ts-text-sm ts-font-semibold ts-p-2 ts-bg-gray-300 ts-rounded-b-none ts-rounded ts-text-blue-700 ts-uppercase"
            >
              {{ $t('gameSetting.main') }}
            </h2>
            <main-setup v-model="model" :validate="errors" />
          </div>
          <br />
          <h2
            class="ts-text-sm ts-font-semibold ts-p-2 ts-bg-gray-300 ts-rounded-b-none ts-rounded ts-text-blue-700 ts-uppercase"
          >
            {{ $t('gameSetting.detail') }}
          </h2>
          <detail-setup v-model="model" :validate="errors" ref="detail" />
          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <ts-button @click="$router.push({ name: 'game-setting' })">{{
                $t('cancel')
              }}</ts-button>
              <ts-button
                class="ml-2 mr-2"
                color="primary"
                outline
                :waiting="waiting_new"
                @click.prevent="onSaveNew"
                >{{ $t('save_add_new') }}</ts-button
              >
              <ts-button
                color="primary"
                :waiting="waiting"
                @click.prevent="onSave"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import MainSetup from './components/main-setup'
import DetailSetup from './components/detail-setup'

export default {
  name: 'gameSettingCreate',
  components: {
    MainSetup,
    DetailSetup
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        game_type_id: 2,
        game_setting: '',
        description: '',
        minute_close_before_result: null,
        minute_allow_cancel_betting: null,
        num_day_allow_payout: null,
        inactive: false,
        game_logo: null,
        details: []
      }
    }
  },
  created() {},
  methods: {
    ...mapActions('administrator/gameSetting', ['store']),
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'game-setting' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model.game_type_id = 2
      this.model.game_setting = ''
      this.model.description = ''
      this.model.minute_close_before_result = null
      this.model.minute_allow_cancel_betting = null
      this.model.num_day_allow_payout = null
      this.model.inactive = false
      this.model.details = []

      this.$refs.detail.createFiveDFirstRow()
    }
  },
  watch: {
    'model.game_type_id': function() {
      this.errors = new Errors()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/gameSetting/RESET_STATE')
    next()
  }
}
</script>
